(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["betty-causes"] && !Shopify.designMode) return;
  try {
    
if (!window.bettyYtBound) {
  window.bettyYtBound = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.yt-facade');
    if (!button) return;
    var id = button.getAttribute('data-youtube-id');
    if (!id) return;
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1';
    frame.title = button.getAttribute('data-title') || 'Video';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    button.replaceWith(frame);
  });
}

  } catch(e) { console.error(e); }
})();
})();
